import { render, staticRenderFns } from "./ShippingTable.vue?vue&type=template&id=6853bea4&scoped=true&"
import script from "./ShippingTable.vue?vue&type=script&lang=js&"
export * from "./ShippingTable.vue?vue&type=script&lang=js&"
import style0 from "./ShippingTable.vue?vue&type=style&index=0&id=6853bea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853bea4",
  null
  
)

export default component.exports